import { render, staticRenderFns } from "./RicGolfRateShow.vue?vue&type=template&id=04f0d4ee"
import script from "./RicGolfRateShow.vue?vue&type=script&lang=ts"
export * from "./RicGolfRateShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports